/* eslint-disable dot-notation */
import React from 'react';
import { Suripanta } from '../suripanta';
export var RedirectHeaderMeta = function RedirectHeaderMeta(_ref) {
  var url = _ref.url,
      _ref$contentCode = _ref.contentCode,
      contentCode = _ref$contentCode === void 0 ? '301' : _ref$contentCode;
  return React.createElement(React.Fragment, null, React.createElement(Suripanta, {
    key: "redirect_metaA",
    parent: "head",
    location: "start",
    type: "meta",
    attributes: [{
      name: 'name',
      value: 'prerender-header'
    }, {
      name: 'content',
      value: "Location: ".concat(window['SEO_PROTOCOL'] ? window['SEO_PROTOCOL'] : window.location.protocol, "//").concat(window['SEO_HOST'] || window.location.host).concat(url)
    }],
    lazyLoad: false
  }), React.createElement(Suripanta, {
    key: "redirect_metaB",
    parent: "head",
    location: "start",
    type: "meta",
    attributes: [{
      name: 'name',
      value: 'prerender-status-code'
    }, {
      name: 'content',
      value: contentCode
    }],
    lazyLoad: false
  }));
};